import {useEffect, useRef, useState} from 'react';
import {setWorkerTimeout} from '../../../app/utils/workerTimerUtils';
import {useSession} from '../../auth/hooks/useSession';

export const useBeforeSessionExpire = (
  threshold: number,
  callback: (event: {remainingTime: number}) => void,
  when = true,
) => {
  const session = useSession();
  const callbackRef = useRef(callback);
  callbackRef.current = callback;
  const [documentHidden, setDocumentHidden] = useState(document.hidden);

  useEffect(() => {
    const listener = () => {
      setDocumentHidden(document.hidden);
    };

    document.addEventListener('visibilitychange', listener);

    return () => {
      document.removeEventListener('visibilitychange', listener);
    };
  }, []);

  useEffect(() => {
    if (!documentHidden && when && session && session.exp) {
      const now = new Date().getTime() / 1000;
      const diff = session.exp - now;

      if (diff > threshold) {
        const delayMs = (diff - threshold) * 1000;
        // Cap delay to prevent setTimeout overflow (max 2^31 - 1 ≈ 24.8 days)
        const MAX_SAFE_DELAY_MS = 2147483647;
        if (delayMs > MAX_SAFE_DELAY_MS) {
          return;
        }
        return setWorkerTimeout(
          () => {
            callbackRef.current({remainingTime: threshold});
          },
          delayMs,
        );
      } else {
        callbackRef.current({remainingTime: diff});
      }
    }
  }, [documentHidden, session, threshold, when]);
};
